import React from "react";
import TonelagGroupsExplorer from "./TonelagGroupsExplorerMultiCorpus";
import tonelagData from "./bokmaalets_tonelagspar_multicorpus.json";

export default function TonelagPage() {
  return <TonelagGroupsExplorer data={tonelagData} />;
}